module.exports = __webpack_public_path__ + "img/1511351376.4dd39266.jpg";